"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _calendarRow = _interopRequireDefault(require("./calendar-row"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class CalendarTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getDates", () => {
      const dates = this.props.calendar.calendarDates;
      // Work out where to highlight breaks between weekends
      // This won't always be after the Sunday or before the Sat because of bank hols
      for (let i = 0; i < dates.length - 1; i++) {
        const thisDay = new Date(dates[i].id);
        const nextDay = new Date(dates[i + 1].id);
        if (nextDay.getDay() - thisDay.getDay() > 1) dates[i].weekBreak = true;
      }
      return dates;
    });
  }
  render() {
    const tiers = this.props.defaultTiers.filter(t => !t.isExpired && t.isInCalendar);

    // Even sized columns regardless of content
    const colWidthPercent = (this.props.isEditingCalendar ? 98 : 100) / (tiers.length + 2) + '%';

    // We need heavier lines between the weekends so define a border style to use.
    const weekBreakStyle = {
      borderBottomWidth: '3px',
      borderBottomColor: '#cbcbcc',
      width: colWidthPercent
    };
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      className: "table-bordered"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, !this.props.isEditingCalendar ? null : /*#__PURE__*/_react.default.createElement("th", {
      style: {
        borderLeftColor: 'transparent',
        borderBottomColor: 'transparent',
        borderTopColor: 'transparent',
        width: '2%'
      }
    }), /*#__PURE__*/_react.default.createElement("th", {
      style: weekBreakStyle
    }, "Date"), tiers.map(t => /*#__PURE__*/_react.default.createElement("th", {
      style: weekBreakStyle,
      key: t.id
    }, t.tierDescription)), tiers.some(t => t.tierRef === 'SPCL') ? null : /*#__PURE__*/_react.default.createElement("th", {
      style: weekBreakStyle
    }, "Other"))), /*#__PURE__*/_react.default.createElement("tbody", null, this._getDates().map(date => /*#__PURE__*/_react.default.createElement(_calendarRow.default, {
      key: date.id,
      calendar: this.props.calendar,
      calendarDate: date,
      tiers: tiers,
      applicationRacing: this.props.calendar.applicationRacing.filter(div => div.calendarDateID === date.id),
      calendarSpecials: this.props.calendar.calendarSpecials.filter(sp => sp.calendarDateID === date.id),
      applicationSpecials: this.props.calendar.applicationSpecials.filter(sp => sp.calendarDateID === date.id),
      weekBreakStyle: date.weekBreak ? weekBreakStyle : null,
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      isEditingCalendar: this.props.isEditingCalendar
    }))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CalendarTable, "partialQueries", {
  Calendar: _mergeBqlQueries({
    id: true,
    calendarDates: {
      id: true
    },
    applicationRacing: {
      id: true,
      calendarDateID: true
    },
    calendarSpecials: {
      id: true,
      calendarDateID: true
    },
    applicationSpecials: {
      id: true,
      calendarDateID: true
    }
  }, _calendarRow.default.partialQueries.Calendar),
  DefaultTiers: {
    id: true,
    tierRef: true,
    tierDescription: true,
    isExpired: true,
    isInCalendar: true
  }
});
var _default = exports.default = CalendarTable;